import { stimulusApplication } from "web-ui/controllers"

function comboBoxAddOption() {
  const text = this.getAttribute("text")
  const value = this.getAttribute("value")
  const selected = this.getAttribute("selected")

  this.targetElements.forEach((target) => {
    const controller = stimulusApplication.getControllerForElementAndIdentifier(
      target,
      "combo-box"
    )

    controller.addOption(value, text)

    if (selected) {
      controller.selectOption(value)
    }
  })
}

export function activate(Turbo) {
  Turbo.StreamActions.combo_box_add_option = comboBoxAddOption
}
